export const getUpdateEntriProviderDetailsBody = (data) => ({
    name: data.provider,
    mode: data.setupType.toUpperCase(),
});
